<template>
  <v-dialog
    v-model="show"
    persistent
    width="1200px"
    scrollable
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
    <lesson-form
      :mode="mode"
      :lesson="lesson"
      @submit="onSubmit"
      @cancel="show = false"
    >
      <template #header>
        <div>{{ title }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </lesson-form>
  </v-dialog>
</template>
<script>
import LessonForm from '@components/Lesson/Form'
export default {
  name: 'LessonFormDialog',
  components: {
    LessonForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      required: true,
      validator: () => ['add', 'edit', 'view'],
    },
    lesson: {
      type: Object,
      default: null,
      required: false,
    },
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    title() {
      if (this.mode === 'add') {
        return 'Add new lesson'
      } else if (this.mode === 'edit') {
        return 'Edit ' + this.bilingualText(this.lesson, 'name', 'name_cn')
      } else {
        return 'View ' + this.bilingualText(this.lesson, 'name', 'name_cn')
      }
    },
  },
  methods: {
    onSubmit(data) {
      this.$emit('submit', data)
    },
  },
}
</script>
